module.exports = __webpack_public_path__ + "img/hole2.388cb552.svg";